module.exports = __webpack_public_path__ + "img/bt_Sports_def.5120d0e6.png";